import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssVarsProvider, CssBaseline } from '@mui/material';
import { Provider } from 'mobx-react';
import theme from '../themes';
import models from '../store';
import AppRoutes from './routes';
import { initializeAnalytics, analyticsArgs } from '../commons/utils/analytics';

function App() {
    useEffect(() => {
        initializeAnalytics(analyticsArgs);
    }, []);

    return (
        <CssVarsProvider theme={theme} defaultMode="light">
            <CssBaseline />
            <Provider store={models}>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </Provider>
        </CssVarsProvider>
    );
}

export default App;
